/**
 * Utility function for calculating user color value
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import Color from 'color'

/**
 * Convert the color object in user profile and/or collaborator settings into hex
 * @param {Object} color The color object
 */
export const convertColorToHex = (color) => {
  const hue = color?.hue
  if (!hue) {
    return null
  }

  // Sanitize hue just in case
  const normalizedHue = parseInt(hue) % 360

  return Color(`hsl(${normalizedHue}, 90%, 65%)`).hex()
}
